"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentTypes = exports.MessageSenders = void 0;
var MessageSenders;
(function (MessageSenders) {
    MessageSenders["AGENT"] = "agent";
    MessageSenders["USER"] = "user";
    MessageSenders["CHATBOT"] = "chatbot";
    MessageSenders["SYSTEM"] = "system";
})(MessageSenders || (exports.MessageSenders = MessageSenders = {}));
var ContentTypes;
(function (ContentTypes) {
    ContentTypes["BUTTON"] = "button";
    ContentTypes["INPUT"] = "input";
    ContentTypes["LIST_ORDERS"] = "list-orders";
    ContentTypes["FINE_PRINT_MODAL"] = "fine-print-modal";
    ContentTypes["LIST_INCLUSIONS"] = "list-inclusions";
    ContentTypes["LIST_ORDER_ITEMS"] = "list-order-items";
})(ContentTypes || (exports.ContentTypes = ContentTypes = {}));
